export const getTenant = /* GraphQL */ `
  query GetTenant($id: ID!) {
    getTenant(id: $id) {
      id
      group
      timeZone
      locale
      automatedCoachingSendTime
      companyName
      #dispatchNumber
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
      accidentReport
      nameLog
      #stripeBillingEmail
      stripeCustomerId
      shortCode
      workmansComp
      customerType
      originationNumber
      logo
      updatedAt
      ownerUserId
      payrollProvider
    }
  }
`;

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      firstName
      lastName
      email
    }
  }
`;


export const usersByTenant = /* GraphQL */ `
  query UsersByTenant(
    $userTenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByTenant(
      userTenantId: $userTenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        userTenantId
      }
      nextToken
    }
  }
`;